import {ISabitler} from "../../constants/types/logbook";

export const sabitlerKaydet = (sabitler: ISabitler) => {
	return {
		type: 'SABITLER_KAYDET' as const,
		payload: sabitler
	};
};

export type AppAction = ReturnType<typeof sabitlerKaydet>;